<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" :title="$t('addInspection.title')" backdrop shadow
            :visible="allowAddInspection" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('safetyShared.basic') }}</h3>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('addInspection.recordLabel')" class="text-left mb-0"
                            v-if="showRecordField">
                            <b-form-input v-model="inspectionPayload.record_no" type="text"
                                :placeholder="$t('addInspection.recordPlaceholder')" class="unit" required></b-form-input>
                            <p v-if="errors && errors.record_no" class="field-error">
                                {{ errors.record_no[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('addInspection.recordLabel')" class="text-left mb-0" v-else>
                            <b-form-input v-model="lastRecord" disabled type="text"
                                :placeholder="$t('addInspection.recordPlaceholder')" class="unit" required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left select_arrow ">
                            <label class="state">{{ $t('addInspection.statusLabel') }}</label>
                            <b-form-select class="f-12" v-model="inspectionPayload.status" :options="statusOptions"
                                @change="onStatusChange" />
                        </div>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label for="inspection-add-datepicker" class="state">{{ $t('addInspection.dateLabel') }}</label>
                        <date-picker v-model="inspectionPayload.date" :formatter="momentFormat" :range-separator="' - '"
                            @clear="inspectionPayload.date = ''" :placeholder="$t('safetyShared.selectDate')"
                            class="date-picker-custom" :teleport="'body'"></date-picker>
                        <p v-if="errors && errors.date" class="field-error">
                            {{ errors.date[0] }}
                        </p>
                    </b-col>
                    <b-col md="6" sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addInspection.startTimeLabel') }}</label>
                        <b-form-input type="time" class="f-12" v-model="inspectionPayload.start_time"></b-form-input>
                    </b-col>
                    <b-col md="6" sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addInspection.endTimeLabel') }}</label>
                        <b-form-input type="time" class="f-12" v-model="inspectionPayload.end_time"></b-form-input>
                    </b-col>
                    <b-col sm="12">
                        <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addInspection.driverLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="inspectionPayload.driver"
                                :options="driverOptions" item-value="id" item-text="label" :reduce="(option) => option.id"
                                @search="searchDriver">
                                <span slot="no-options">
                                    {{ $t('addInspection.searchDriver') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.driver" class="field-error">
                                {{ errors.driver[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <div class="text-left select_arrow mt-3">
                            <label class="state">{{ $t('addInspection.vehicleLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="inspectionPayload.vehicle"
                                :options="vehicleOptions" item-value="id" item-text="label" :reduce="(option) => option.id"
                                @search="searchVehicle">
                                <span slot="no-options">
                                    {{ $t('addInspection.searchVehicle') }}
                                </span>
                            </v-select>
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <div class="text-left select_arrow mt-3">
                            <label class="state">{{ $t('addInspection.trailerLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="inspectionPayload.trailer"
                                :options="trailerOptions" item-value="id" item-text="label" :reduce="(option) => option.id"
                                @search="searchTrailer">
                                <span slot="no-options">
                                    {{ $t('addInspection.searchTrailer') }}
                                </span>
                            </v-select>
                        </div>
                        <hr class="mt-4" />
                    </b-col>
                    <b-col sm="12">
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addInspection.divisionLabel') }}</label>
                            <v-select class="f-12" :clearable="false" :options="allDivisions"
                                v-model="inspectionPayload.division" :reduce="(option) => option.id" />
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addInspection.citationsLabel') }}</label>
                            <v-select class="f-12" @search="searchCitations" :options="allCitations" multiple
                                :reduce="(option) => option.id" v-model="inspectionPayload.linked_tickets" />
                            <p v-if="citationsNotClosed" class="field-error">{{ $t('editInspection.citationsNotClosed') }}
                            </p>
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <hr class="mt-4" />
                        <div class="text-left select_arrow">
                            <label class="state">{{ $t('addInspection.levelLabel') }}</label>
                            <b-form-select v-model="inspectionPayload.level" class="f-12" :options="[{
                                value: null,
                                text: ''
                            },
                            {
                                value: 'I',
                                text: '|'
                            },
                            {
                                value: 'II',
                                text: '||'
                            },
                            {
                                value: 'III',
                                text: '|||'
                            }
                            ]" />
                        </div>
                    </b-col>
                    <b-col sm="12" class="text-left mt-3">
                        <label class="state">{{ $t('addInspection.reportLabel') }}</label>
                        <b-form-input type="text" v-model="inspectionPayload.report_number" class="f-12"
                            :placeholder="$t('addInspection.reportPlaceholder')"></b-form-input>
                    </b-col>
                    <b-col sm="12">
                        <div class="text-left select_arrow mt-3">
                            <label class="state">{{ $t('addInspection.stateLabel') }}</label>
                            <v-select class="bg_white w-100" v-model="inspectionPayload.state" :options="states"
                                item-value="id" item-text="label" :reduce="(option) => option.id">
                            </v-select>
                        </div>
                    </b-col>
                    <b-col md="12" class="text-left mt-3">
                        <label class="state text-left">{{ $t('addInspection.descriptionLabel') }}</label>
                        <b-form-textarea id="textarea" :placeholder="$t('addInspection.notesPlaceholder')" class="f-12"
                            rows="5" v-model="inspectionPayload.notes"></b-form-textarea>
                    </b-col>
                </b-row>
                <hr class="m-4" />
                <b-row class="px-4 mb-7rem">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addInspection.dataq') }}</h3>
                    <b-col sm="12" class="text-left mb-2">
                        <b-row>
                            <b-col sm="12" class="text-left">
                                <label>{{ $t('addInspection.yesLabel') }}</label>
                                <b-form-checkbox name="check-button" class="ml-0-6rem"
                                    v-model="inspectionPayload.dataq_section" switch size="lg"></b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="12" v-if="inspectionPayload.dataq_section">
                        <b-row>
                            <b-col sm="12" class="text-left mt-3">
                                <label class="state">{{ $t('addInspection.dataqStatusLabel') }}</label>
                                <b-form-select v-model="inspectionPayload.dataq_status" class="f-12"
                                    :options="dataqStatusOptions" />
                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label for="dataq_submitted_date" class="state">{{
                                    $t('addInspection.dataqSubmittedDateLabel') }}</label>
                                <date-picker v-model="inspectionPayload.dataq_submitted_date" :formatter="momentFormat"
                                    :range-separator="' - '" @clear="inspectionPayload.dataq_submitted_date = null"
                                    :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom"
                                    :teleport="'body'"></date-picker>

                            </b-col>
                            <b-col sm="12" class="text-left mt-3">
                                <label for="dataq_decision_date" class="state">{{ $t('addInspection.dataqDecisionDateLabel')
                                }}</label>
                                <date-picker v-model="inspectionPayload.dataq_decision_date" :formatter="momentFormat"
                                    :range-separator="' - '" @clear="inspectionPayload.dataq_decision_date = null"
                                    :placeholder="$t('safetyShared.selectDate')" class="date-picker-custom"
                                    :teleport="'body'"></date-picker>
                                <p v-if="dataqDecisionMissing" class="field-error">{{
                                    $t('editInspection.dataqDecisionRequired') }}</p>

                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <div class="sidebar-footer position-fixed">
                    <div class="text-right modal-footer border-0 p-0">
                        <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{
                            $t('safetyShared.cancel') }}</b-button>
                        <b-button class="mx-0 h-40px px-2 mr-3" @click="onAddNewInspection(true)"
                            variant="outline-primary">{{ $t('safetyShared.saveAndOpen') }}</b-button>
                        <b-button class="mx-0 h-40px w-100px" @click="onAddNewInspection()" variant="primary">{{
                            $t('safetyShared.save') }}</b-button>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <DeleteModal v-if="overturnedDataqConfirm" :message="`<p class='f-16 font-weight-normal mb-0'>${$t('editInspection.overturnedDataqConfirm')}<br/>${$t('editInspection.confirmCloseStatus')}</p>`"
            :updateMessage="true" :removeMessage="''" @confirm="verifyOverturnedDataq" />
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import * as moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";
import DeleteModal from "@/components/DeleteModal.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: { vSelect, DatePicker, DeleteModal },
    name: "AddInspection",
    props: {
        allowAddInspection: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        ...mapGetters([
            "allCountries",
            "userCompany",
            "allEquipments",
            "allDrivers",
            "divisions"
        ]),
        yesNoNullOptions() {
            return [
                { value: null, text: '-' },
                { value: false, text: this.$t('safetyShared.no') },
                { value: true, text: this.$t('safetyShared.yes') },
            ];
        },
        dataqStatusOptions() {
            return [
                { value: 'Not Started', text: this.$t('safetyShared.statusNotStarted') },
                { value: 'Submitted', text: this.$t('safetyShared.statusSubmitted') },
                { value: 'Pending', text: this.$t('safetyShared.statusPending') },
                { value: 'Overturned', text: this.$t('safetyShared.statusOverturned') },
                { value: 'Upheld', text: this.$t('safetyShared.statusUpheld') },
            ];
        },
        statusOptions() {
            return [
                { value: 'New', text: this.$t('safetyShared.statusNew') },
                { value: 'Open', text: this.$t('safetyShared.statusOpen') },
                { value: 'Closed', text: this.$t('safetyShared.statusClosed') },
                { value: 'Urgent', text: this.$t('safetyShared.statusUrgent') },
            ];
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
        isClosing() {
            return this.inspectionPayload.status === 'Closed';
        },
        // Rule 1: DataQ is on but no decision date — blocks closing.
        dataqDecisionMissing() {
            return this.isClosing && this.inspectionPayload.dataq_section && !this.inspectionPayload.dataq_decision_date;
        },
        // Rule 2: an attached citation is still New/Open/Urgent — blocks closing.
        citationsNotClosed() {
            if (!this.isClosing || !this.inspectionPayload.linked_tickets.length) return false;
            const openStatuses = ['New', 'Open', 'Urgent'];
            return this.inspectionPayload.linked_tickets.some((id) => {
                const citation = this.allCitations.find((c) => c.id === id);
                return citation && openStatuses.includes(citation.status);
            });
        },
        // Hard blocks that prevent closing outright.
        isCloseBlocked() {
            return this.dataqDecisionMissing || this.citationsNotClosed;
        },
        // Rule 3: attached citation went to court and was overturned, but DataQ isn't
        // completed — a soft recommendation (confirm, not a hard block).
        needsOverturnedDataqConfirm() {
            if (!this.isClosing || !this.inspectionPayload.linked_tickets.length) return false;
            // Only recommend when DataQ hasn't been completed (section not enabled).
            if (this.inspectionPayload.dataq_section) return false;
            return this.inspectionPayload.linked_tickets.some((id) => {
                const citation = this.allCitations.find((c) => c.id === id);
                return citation && citation.court === true && citation.outcome === 'Overturned';
            });
        },
        closeInvalidReason() {
            // Spells out which hard rule is blocking the close.
            if (this.dataqDecisionMissing) return this.$t('editInspection.dataqDecisionRequired');
            if (this.citationsNotClosed) return this.$t('editInspection.citationsNotClosed');
            return '';
        },
    },
    data() {
        return {
            errors: {},
            previousStatus: 'New',
            states: [],
            showRecordField: false,
            overturnedDataqConfirm: false,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
                    if (!value) return null
                    const formats = [
                        'll', 'LL',
                        'MMM D, YYYY', 'MMMM D, YYYY',
                        'M/D/YYYY', 'MM/DD/YYYY',
                        'M-D-YYYY', 'MM-DD-YYYY',
                        'YYYY-MM-DD', 'YYYY/MM/DD',
                        'D MMM YYYY', 'D MMMM YYYY',
                        'D/M/YYYY', 'DD/MM/YYYY',
                    ]
                    const m = moment(value, formats, true)
                    if (m.isValid()) return m.toDate()
                    const lenient = moment(value)
                    return lenient.isValid() ? lenient.toDate() : null
                }
            },
            lastRecord: null,
            inspectionPayload: {
                record_no: "",
                driver: null,
                status: "New",
                vehicle: null,
                trailer: null,
                date: null,
                start_time: null,
                end_time: null,
                level: null,
                state: "",
                report_number: '',
                notes: "",
                division: null,
                linked_tickets: [],
                dataq_submitted: false,
                dataq_status: "Not Started",
                dataq_submitted_date: null,
                dataq_decision_date: null,
                dataq_section: false

            },
            driverOptions: [],
            vehicleOptions: [],
            trailerOptions: [],
            allCitations: [],
        }
    },
    methods: {
        ...mapActions([
            "getAllCountries",
            "getFilteredEquipments",
            "getFilteredDrivers",
            "setLoader",
            "addDotInspection",
            "setNotification",
            "getLastRecord",
            "getAllCitations"
        ]),
        verifyOverturnedDataq(status) {
            this.overturnedDataqConfirm = false;
            if (!status) {
                // Cancelled — revert to the status before the attempted close.
                this.inspectionPayload.status = this.previousStatus;
                return;
            }
            // Confirmed — accept the close.
            this.previousStatus = this.inspectionPayload.status;
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async onStatusChange(newVal) {
            if (newVal === 'Closed') {
                // Hard blocks (rules 1 & 2) — revert to previous status and show a red alert.
                if (this.isCloseBlocked) {
                    this.setNotification({
                        msg: this.closeInvalidReason,
                        type: "error",
                        color: "red",
                    });
                    this.$nextTick(() => {
                        this.inspectionPayload.status = this.previousStatus;
                    });
                    return;
                }
                if (this.needsOverturnedDataqConfirm) {
                    this.overturnedDataqConfirm = true;
                }
            }
            this.previousStatus = newVal;
        },
        validateClose() {
            // Hard blocks (rules 1 & 2) — cannot close until resolved (save-time safety net).
            if (!this.isCloseBlocked) return true;
            this.setNotification({
                msg: this.closeInvalidReason,
                type: "error",
                color: "red",
            });
            return false;
        },
        async onAddNewInspection(openInspection = false) {
            if (!this.validateClose()) return;
            try {
                const nullKeys = this.checkNullValues({
                    driver: this.inspectionPayload.driver,
                    date: this.inspectionPayload.date,
                    ...this.showRecordField ? { record_no: this.inspectionPayload.record_no } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    if (!this.showRecordField) delete this.inspectionPayload.record_no
                    const record = await this.addDotInspection({ ...this.inspectionPayload, company: this.userCompany, date: moment(this.inspectionPayload.date).format('YYYY-MM-DD'), dataq_submitted_date: this.inspectionPayload.dataq_submitted_date ? moment(this.inspectionPayload.dataq_submitted_date).format('YYYY-MM-DD') : null, dataq_decision_date: this.inspectionPayload.dataq_decision_date ? moment(this.inspectionPayload.dataq_decision_date).format('YYYY-MM-DD') : null });
                    await this.setNotification({
                        msg: this.$t('addInspection.added'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false);
                    if (openInspection) this.$emit("inspectionAdded", record)
                    else this.$emit("inspectionAdded", null)
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }

        },
        resetPopup() {
            this.previousStatus = 'New'
            this.inspectionPayload = {
                record_no: "",
                driver: null,
                status: "New",
                vehicle: null,
                trailer: null,
                date: null,
                start_time: null,
                end_time: null,
                level: null,
                state: "",
                report_number: '',
                notes: "",
                division: null,
                linked_tickets: [],
                dataq_submitted: false,
                dataq_status: "Not Started",
                dataq_submitted_date: null,
                dataq_decision_date: null,
                dataq_section: false
            },
                this.errors = {}
            this.vehicleOptions = [],
                this.trailerOptions = [],
                this.allCitations = []
            this.$emit('close');
        },
        async searchDriver(searchText) {
            if (searchText && searchText.length >= 2) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                driverRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.name,
                    });
                });
                this.driverOptions = this.driverOptions.concat(options)
                this.driverOptions = [...new Map(this.driverOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchVehicle(searchText) {
            if (searchText) {
                let options = [];
                const vehicleRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Vehicle" });
                vehicleRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.vehicleOptions = this.vehicleOptions.concat(options)
                this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchTrailer(searchText) {
            if (searchText) {
                let options = [];
                const trailerRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Trailer" });
                trailerRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.trailerOptions = this.trailerOptions.concat(options)
                this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchCitations(searchText) {
            if (searchText) {
                let options = []
                let url = `page=1&page_size=25&search=${searchText}`;
                const citationRecords = await this.getAllCitations(url);
                citationRecords.records.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.record_no,
                        status: x.status,
                        court: x.court,
                        outcome: x.outcome
                    });
                });
                this.allCitations = this.allCitations.concat(options)
                this.allCitations = [...new Map(this.allCitations.map(item => [item['id'], item])).values()]
            }
        },
        async getCountries() {
            await this.getAllCountries();
            const countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates(countries[0]);
        },
        getStates(selectedOption) {
            this.states = this.allCountries
                .filter((country) => country.id === selectedOption.id)[0]
                .state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
            this.inspectionPayload.state = this.states.filter(
                (state) => state.label === "-"
            )[0].id;
        }
    },
    watch: {
        async allowAddInspection() {
            if (this.allowAddInspection) {
                this.setLoader(true)
                const lastItemRecord = await this.getLastRecord({
                    company_id: this.userCompany,
                    query: `model_name=safetyinspection`
                })
                if (lastItemRecord) this.lastRecord = lastItemRecord + 1;
                else this.showRecordField = true
                this.setLoader(false)
            }
        }
    },
    async mounted() {
        await this.getCountries();
    },
}
</script>